import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import zhHans from 'vuetify/es5/locale/zh-Hans';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      options: {
        customProperties: true,
      },
    themes: {
      light:{
        primary: '#0F95B0',
        secondary: '#005F6B',
        accent: '#2FC4E5',
        error: '#B00020',
        info: '#0e64cf',
        success: '#0fb07a',
        warning: '#e2766b',
      },
    },
  },
    lang: {
      locales: { zhHans },
      current: 'zh-Hans',
    },
  icons: {
    iconfont: 'md',
  },
});
